import { ArrowLeftIcon } from '@heroicons/react/24/solid'
import { FC } from 'react'

import { cn } from '@/app/utils'

type Props = {
  onClick?: () => void
  className?: string
  disabled?: boolean
}

const GoBackButton: FC<Props> = ({ disabled, className, onClick }) => (
  <button
    aria-label="Назад"
    className={cn(
      'flex h-40 w-40 items-center justify-center rounded-full bg-[rgba(16,24,32,0.1)] p-8 outline-none transition-colors hover:bg-grey-30 xs:h-28 xs:w-28 xs:p-4',
      className
    )}
    onClick={onClick}
    disabled={disabled}
  >
    <ArrowLeftIcon className="h-24 w-24 text-bronze-40 xs:h-16 xs:w-16" />
  </button>
)

export default GoBackButton
